import { types, Instance } from 'mobx-state-tree';
const { model, string, identifierNumber, maybeNull, maybe } = types;

export const UserModel = model('UserModel', {
  id: identifierNumber,
  mail: string,
  status: maybe(string),
  createdAt: maybeNull(string),
  deleted_at: maybeNull(string),
  dn: string,
  entity: string,
  name: maybeNull(string),
  updated_at: maybeNull(string),
  created_at: maybeNull(string),
  uid: string,
});
export type IUserModel = Instance<typeof UserModel>;

export const GroupModel = model('GroupModel', {
  id: identifierNumber,
  status: maybe(string),
  createdAt: maybeNull(string),
  deleted_at: maybeNull(string),
  dn: string,
  cn: string,
  entity: string,
  object: maybeNull(string),
  updated_at: maybeNull(string),
  created_at: maybeNull(string),
});
export type IGroupModel = Instance<typeof GroupModel>;

export const DepartmentModel = model('DepartmentModel', {
  id: identifierNumber,
  status: maybe(string),
  createdAt: maybeNull(string),
  deleted_at: maybeNull(string),
  dn: string,
  ou: string,
  entity: string,
  object: maybeNull(string),
  updated_at: maybeNull(string),
  created_at: maybeNull(string),
});

export type IDepartmentModel = Instance<typeof DepartmentModel>;
